import { useEffect } from 'react';
import { getToken } from 'firebase/messaging';
import { messaging } from './get-firebase-messaging-instance';
import { config } from '../env-helpers';
import apolloClient from '@/container/apollo-client';
import { CREATE_FCM_TOKEN } from '@/graphql/mutation.graphql';
import {
  CreateUserWorkspaceFcmTokenMutation,
  CreateUserWorkspaceFcmTokenMutationVariables,
  NotificationPlatformEnum,
} from '@/types/generated/graphql';

const options = { vapidKey: config.VAROSA_FIREBASE_VAPID_KEY };
let firebaseInitialized = false;

export function useFirebaseNotification() {
  async function initializeFirebase() {
    const firebaseToken = await getFirebaseToken().catch(console.error);
    if (firebaseToken) {
      await submitFCMToken(firebaseToken);
    }
  }

  useEffect(() => {
    if (firebaseInitialized) return;
    firebaseInitialized = true;
    initializeFirebase();
  }, []);
}

async function getFirebaseToken() {
  try {
    const permission = await Notification.requestPermission();
    const allowed = permission === 'granted';
    if (!allowed) {
      console.info('Notification permission not granted');
    }

    if (!messaging) {
      console.info('Firebase messaging is not supported by this browser');
      return;
    }

    const firebaseToken = await getToken(messaging, options);
    return firebaseToken;
  } catch (error) {
    console.error('Error requesting firebase permission:', error);
  }
}

async function submitFCMToken(token: string) {
  return apolloClient().mutate<CreateUserWorkspaceFcmTokenMutation, CreateUserWorkspaceFcmTokenMutationVariables>({
    mutation: CREATE_FCM_TOKEN,
    variables: {
      input: {
        token,
        platform: NotificationPlatformEnum.web,
      },
    },
  });
}
